/**
 * Extention for web3.js. Adds the namespace "nrg" to web3.
 * Public API extension
 *
 *
 * Usage:
 *
 * Web3 = require('web3');<br>
 * web3Extension = require('@energi/web3-ext');<br>
 *
 * web3 = new Web3('https://nodeapi.test3.energi.network');<br>
 * web3Extension(web3);<br>
 * result = await web3.nrg.getBalance(address);<br>
 *
 *
 * <br>
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * BSD-3-Clause License
 *
 *
 * @module nrg.js
 * @extends web3
 * @class web3.nrg
 * @since 0.0.1
*/
var extend = function extend(web3) {
  web3.nrg = web3.eth;
};

module.exports = extend;